import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/paymentmethods',
    name: 'PaymentMethodsPage',
    component: () => import('@/modules/paymentMethods/views/PaymentMethodsPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
